<template>
  <header class="header">
    <div class="header__content">
      <router-link :to="{ name: 'ViewHome' }" class="header-logo">
        <img src="/static/images/bkf-logo-compressed.png" alt="">
      </router-link>
    </div>
    <div class="menu-toggle">
      <button class="menu-toggle__button"></button>
    </div>
  </header>
</template>
<script>
export default {
  name: 'AppHeader'
}
</script>

<style lang="scss" scoped>
  @import './app-header'
</style>



// WEBPACK FOOTER //
// src/components/AppHeader/AppHeader.vue